import moment from "moment";
import React, { useEffect } from "react";
import { Col } from "react-bootstrap";
import classes from "./MonthSmallCalander.module.css";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { useState } from "react";
import Colors from "../../stories/assets/Colors";
import { coachDemoImg } from "../../constant/imagePath";

const statusArray = [
  {
    id: "sch-1",
    userData: {
      displayName: "Tyler",
      profile: coachDemoImg,
    },
    startTime: moment(moment().add(-3, "hours").format())
      .add(0, "days")
      .format(),
    endTime: moment(moment().add(3, "hours").format()).add(0, "days").format(),
    eventDate: moment().add(0, "days").format(),
    type: "1-on-1",
    title: "Tennis Lesson",
    location: "DeWitt Clinton Park, W 54th St, New York, NY",
    price: 64,
    status: "pending",
    timeLeft: "14 hrs",
  },
  {
    id: "sch-2",
    userData: {
      displayName: "Kate",
      profile: coachDemoImg,
    },
    startTime: moment(moment().add(4, "hours").format())
      .add(0, "days")
      .format(),
    endTime: moment(moment().add(5, "hours").format()).add(0, "days").format(),
    eventDate: moment().add(2, "days").format(),
    type: "1-on-1",
    title: "Tennis Lesson",
    location: "DeWitt Clinton Park, W 54th St, New York, NY",
    price: 64,
    status: "accepted",
    timeLeft: "14 hrs",
  },
  {
    id: "sch-3",
    userData: {
      displayName: "Tyler",
      profile: coachDemoImg,
    },
    startTime: moment(moment().add(6, "hours").format())
      .add(0, "days")
      .format(),
    endTime: moment(moment().add(8, "hours").format()).add(0, "days").format(),
    eventDate: moment().add(0, "days").format(),
    type: "1-on-1",
    title: "Tennis Lesson",
    location: "DeWitt Clinton Park, W 54th St, New York, NY",
    price: 64,
    status: "evaluate",
    timeLeft: "14 hrs",
  },
];

const DayName = () => {
  return (
    <div className={classes?.dayNameContainer}>
      {moment.weekdays().map((item, index) => (
        <span className={[classes?.dayContainer, classes?.day].join(" ")}>
          {item[0]}
        </span>
      ))}
    </div>
  );
};

const Date = ({ StartDate, eventArray, setDate, selectedDate }) => {
  const daysCount = moment(StartDate).daysInMonth();
  const startOfWeek = moment(StartDate).startOf("week").format();
  const dateDiff = moment(StartDate).diff(moment(startOfWeek), "day");

  let arrayData = Array(daysCount + dateDiff).fill(0);
  return (
    <div className={classes?.dayNameContainer}>
      {arrayData.map((item, index) => {
        const FilterData = eventArray.filter((innerItem, innerIndex) => {
          return (
            moment(innerItem?.eventDate).format("DD-MM-YYYY") ==
            moment(StartDate)
              .add(index - dateDiff, "days")
              .format("DD-MM-YYYY")
          );
        });

        return (
          <span
            onClick={() => {
              dateDiff < index + 1 &&
                setDate !== undefined &&
                setDate(
                  moment(StartDate)
                    .add(index - dateDiff, "days")
                    .format()
                );
            }}
            className={[
              classes?.dayContainer,
              classes?.dateText,
              (moment(StartDate)
                .add(index - dateDiff, "days")
                .format("dddd") == "Sunday" ||
                moment(StartDate)
                  .add(index - dateDiff, "days")
                  .format("dddd") == "Saturday") &&
                classes?.weekEndDate,
            ].join(" ")}
          >
            <div
              className={
                moment(StartDate)
                  .add(index - dateDiff, "days")
                  .format("DD-MM-YYYY") ==
                  moment(selectedDate).format("DD-MM-YYYY") &&
                classes?.currentDate
              }
            >
              {dateDiff >= index + 1
                ? ""
                : moment(StartDate)
                    .add(index - dateDiff, "days")
                    .format("D")}
            </div>
            <div
              className={[
                classes?.eventPointerContainer,
                moment(StartDate)
                  .add(index - dateDiff, "days")
                  .format("DD-MM-YYYY") == moment().format("DD-MM-YYYY") &&
                  classes?.currentDateEventPointerContainer,
              ].join(" ")}
            >
              {FilterData?.map((filItem, filIndex) =>
                filIndex < 2 ? (
                  <span
                    className={[
                      classes?.eventPointer,
                      moment(StartDate)
                        .add(index - dateDiff, "days")
                        .format("DD-MM-YYYY") ==
                        moment().format("DD-MM-YYYY") &&
                        classes?.eventPointerBorder,
                      classes[filItem?.status],
                    ].join(" ")}
                    style={{
                      marginLeft: filIndex == 1 ? -3 : 0,
                    }}
                  ></span>
                ) : null
              )}
            </div>
          </span>
        );
      })}
    </div>
  );
};

const Header = ({ StartDate, setMonth }) => {
  const currentMonth = moment().startOf("month").format();
  return (
    <div className={classes?.headerContainer}>
      <span className={classes?.monthName}>
        {moment(StartDate).format("MMMM")}
      </span>
      <div>
        <IoIosArrowBack
          onClick={() => {
            moment(StartDate).diff(moment(currentMonth), "month") > 0 &&
              setMonth(moment(StartDate).add(-1, "month").format());
          }}
          color={
            moment(StartDate).diff(moment(currentMonth), "month") > 0
              ? Colors?.neutralShadesOfNero
              : Colors?.neutralShadesOfPinkSwan
          }
        />
        <IoIosArrowForward
          onClick={() => {
            setMonth(moment(StartDate).add(1, "month").format());
          }}
          style={{
            marginLeft: 12,
          }}
        />
      </div>
    </div>
  );
};

const MonthSmallCalander = ({
  value = moment().format(),
  setValue,
  eventArray = [],
}) => {
  const [monthStartDate, setMonthStartDate] = useState(
    moment(value).startOf("month").format()
  );

  useEffect(() => {
    console.log("value", value);
    setMonthStartDate(moment(value).startOf("month").format());
  }, [value]);
  return (
    <div className={classes?.calendarContainer}>
      <Header StartDate={monthStartDate} setMonth={setMonthStartDate} />
      <DayName />
      <Date
        selectedDate={value}
        StartDate={monthStartDate}
        eventArray={eventArray}
        setDate={setValue}
      />
    </div>
  );
};

export default MonthSmallCalander;
